import script from "./PayoutsHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./PayoutsHistory.vue?vue&type=script&setup=true&lang=js"

import "./PayoutsHistory.vue?vue&type=style&index=0&id=1a7be3bb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7be3bb"]])

export default __exports__